<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>Acompanhamento de Remessa</h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <div *ngIf="isLoading" style="min-height: 120px" class="d-flex justify-content-center">
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <mat-accordion [hidden]="isLoading" class="example-headers-align" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Total de Pedidos: </mat-panel-title>
          <mat-panel-description>
            <strong>{{ pagingTotalPedidos.length }}</strong>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-progress-bar
          color="primary"
          mode="indeterminate"
          [hidden]="!isLoadingTotalPedidos"
        ></mat-progress-bar>
        <mat-card-content class="no-padding">
          <div [hidden]="isLoadingTotalPedidos || totalPedidos?.data?.length === 0">
            <div>
              <table
                id="relatorios"
                mat-table
                [dataSource]="totalPedidos"
                class="table-sm"
              >
      
                <ng-container matColumnDef="pedidoID">
                  <th mat-header-cell *matHeaderCellDef>NRT</th>
                  <td mat-cell *matCellDef="let totalPedidos">
                    {{ totalPedidos?.pedidoID }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="documento">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let totalPedidos">
                    {{ totalPedidos?.documento }}
                  </td>
                </ng-container>
    
                <ng-container matColumnDef="dtRecep">
                  <th mat-header-cell *matHeaderCellDef>Data Recepção</th>
                  <td mat-cell *matCellDef="let totalPedidos">
                    {{ totalPedidos?.dtRecep  | date: "dd/MM/yyyy - HH:mm:ss" }}
                  </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
            <app-paginacao *ngIf="pagingTotalPedidos?.length > 5"
              [pageIndex]="pagingTotalPedidos?.index"
              [pageSize]="pagingTotalPedidos?.size"
              [length]="pagingTotalPedidos?.length"
              (page)="onPageChange($event, 'pagingTotalPedidos')"
              [pageSizeOptions]="[5]"></app-paginacao>
          </div>
          <div
            *ngIf="!isLoadingTotalPedidos && totalPedidos?.data?.length === 0"
            class="d-flex justify-content-center align-items-center"
            style="height: 100px"
          >
            Nenhum resultado encontrado!
          </div>
        </mat-card-content>
      </mat-expansion-panel>
  
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Total de Pedidos não recepcionados: </mat-panel-title>
          <mat-panel-description>
            <strong>{{ pagingNaoRecepcionados.length }}</strong>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-progress-bar
          color="primary"
          mode="indeterminate"
          [hidden]="!isLoadingNaoRecepcionados"
        ></mat-progress-bar>
        <mat-card-content class="no-padding">
          <div [hidden]="isLoadingNaoRecepcionados || totalPedidosNaoRecepcionados?.data?.length === 0">
            <div>
              <table
                id="relatorios"
                mat-table
                [dataSource]="totalPedidosNaoRecepcionados"
                class="table-sm"
              >
      
                <ng-container matColumnDef="pedidoID">
                  <th mat-header-cell *matHeaderCellDef>NRT</th>
                  <td mat-cell *matCellDef="let totalPedidosNaoRecepcionados">
                    {{ totalPedidosNaoRecepcionados?.pedidoID }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="documento">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let totalPedidosNaoRecepcionados">
                    {{ totalPedidosNaoRecepcionados?.documento }}
                  </td>
                </ng-container>
    
                <ng-container matColumnDef="dtRecep">
                  <th mat-header-cell *matHeaderCellDef>Data Recepção</th>
                  <td mat-cell *matCellDef="let totalPedidosNaoRecepcionados">
                    {{ totalPedidosNaoRecepcionados?.dtRecep  | date: "dd/MM/yyyy - HH:mm:ss" }}
                  </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
            <app-paginacao *ngIf="pagingNaoRecepcionados?.length > 5"
              [pageIndex]="pagingNaoRecepcionados?.index"
              [pageSize]="pagingNaoRecepcionados?.size"
              [length]="pagingNaoRecepcionados?.length"
              (page)="onPageChange($event, 'pagingNaoRecepcionados')"
              [pageSizeOptions]="[5]"></app-paginacao>
          </div>
          <div
            *ngIf="!isLoadingNaoRecepcionados && totalPedidosNaoRecepcionados?.data?.length === 0"
            class="d-flex justify-content-center align-items-center"
            style="height: 100px"
          >
            Nenhum resultado encontrado!
          </div>
        </mat-card-content>
      </mat-expansion-panel>
  
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Total de Pedidos recepcionados: </mat-panel-title>
          <mat-panel-description>
            <strong>{{ pagingRecepcionados.length }}</strong>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-progress-bar
        color="primary"
        mode="indeterminate"
        [hidden]="!isLoadingRecepcionados"
      ></mat-progress-bar>
      <mat-card-content class="no-padding">
        <div [hidden]="isLoadingRecepcionados || totalPedidosRecepcionados?.data?.length === 0">
          <div>
            <table
              id="relatorios"
              mat-table
              [dataSource]="totalPedidosRecepcionados"
              class="table-sm"
            >
    
              <ng-container matColumnDef="pedidoID">
                <th mat-header-cell *matHeaderCellDef>NRT</th>
                <td mat-cell *matCellDef="let totalPedidosRecepcionados">
                  {{ totalPedidosRecepcionados?.pedidoID }}
                </td>
              </ng-container>
  
              <ng-container matColumnDef="documento">
                <th mat-header-cell *matHeaderCellDef>Documento</th>
                <td mat-cell *matCellDef="let totalPedidosRecepcionados">
                  {{ totalPedidosRecepcionados?.documento }}
                </td>
              </ng-container>
  
              <ng-container matColumnDef="dtRecep">
                <th mat-header-cell *matHeaderCellDef>Data Recepção</th>
                <td mat-cell *matCellDef="let totalPedidosRecepcionados">
                  {{ totalPedidosRecepcionados?.dtRecep  | date: "dd/MM/yyyy - HH:mm:ss" }}
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <app-paginacao *ngIf="pagingRecepcionados?.length > 5"
            [pageIndex]="pagingRecepcionados?.index"
            [pageSize]="pagingRecepcionados?.size"
            [length]="pagingRecepcionados?.length"
            (page)="onPageChange($event, 'pagingRecepcionados')"
            [pageSizeOptions]="[5]"></app-paginacao>
        </div>
        <div
          *ngIf="!isLoadingRecepcionados && totalPedidosRecepcionados?.data?.length === 0"
          class="d-flex justify-content-center align-items-center"
          style="height: 100px"
        >
          Nenhum resultado encontrado!
        </div>
      </mat-card-content>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button *ngIf="!isLoading" mat-flat-button type="button" color="success" (click)="downloadExcel()"
      [disabled]="isLoadingDownload">
      <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
        <mat-spinner diameter="20" color="dark"></mat-spinner>
        &nbsp; Baixando
      </span>
      <span *ngIf="!isLoadingDownload">
        <i class="fas fa-file-excel"></i> Download Excel
      </span>
    </button>
    <button mat-flat-button color="info" mat-dialog-close="cancel">Fechar</button>
  </div>
</div>
